import { DistanceUnit, kmToMiles } from 'lib/geo/distanceUnits'

export function getDistanceLabel(distanceKm: number, distanceFrom: string, distanceUnitOutput: DistanceUnit): string | null {
  if (distanceKm > 20) {
    return null
  }
  if (distanceUnitOutput === 'km') {
    if (distanceKm < 0.1) {
      const meters = (distanceKm * 1000).toFixed(1)
      return `${meters.replace(/\.0$/, '')}m from ${distanceFrom}`
    }

    return `${distanceKm.toFixed(1).replace(/\.0$/, '')}km from ${distanceFrom}`
  }
  if (distanceUnitOutput === 'mi') {
    const miles = kmToMiles(distanceKm)
    return `${miles.toFixed(1).replace(/\.0$/, '')} mi from ${distanceFrom}`
  }
  return null
}
